export default __webpack_public_path__ + "static/media/0116.d98b3a30.png";